import React, { ReactNode } from "react";
import { Link } from "react-router-dom";
import { resolveDocsHref } from "../shared/paths";

/**
 * Every link the docs render: a docs-root path ("/task-apis/limits", the form content and API data
 * use) opens inside the site; another site opens in a new tab, safely; `#anchor` stays on the page.
 */
export const DocsLink = ({ href, children, className }: { href?: string; children?: ReactNode; className?: string }) => {
  if (!href) return <span className={className}>{children}</span>;
  const target = resolveDocsHref(href);
  if (target.external) {
    return (
      <a href={target.href} className={className} target="_blank" rel="noopener noreferrer">
        {children}
      </a>
    );
  }
  if (target.href.startsWith("#")) {
    return (
      <a href={target.href} className={className}>
        {children}
      </a>
    );
  }

  return (
    <Link to={target.href} className={className}>
      {children}
    </Link>
  );
};
